"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _paymentSettings = require("@/api/appBasicSetup/paymentSettings");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TransferAccount',
  data: function data() {
    return {
      showDialog: true,
      loading: false,
      tableData: [],
      page: 1,
      size: 10,
      total: 0,
      title: '',
      OperationType: '',
      dialogVisible: false,
      ruFrom: {
        remark: '',
        alipayAppId: '',
        rootCertContent: '',
        publicKey: '',
        privateKey: '',
        alipayPublicCertContent: '',
        certContent: ''
      },
      rules: {
        // remark: [
        //   { required: true, message: '请输入备注名称', trigger: 'blur' }
        // ],
        // alipayAppId: [
        //   { required: true, message: '请输入支付宝APPID', trigger: 'blur' }
        // ],
        // rootCertContent: [
        //   { required: true, message: '请输入支付宝根证书', trigger: 'blur' }
        // ],
        // publicKey: [
        //   { required: true, message: '请输入支付宝公钥', trigger: 'blur' }
        // ],
        // privateKey: [
        //   { required: true, message: '请输入支付宝私钥', trigger: 'blur' }
        // ],
        // alipayPublicCertContent: [
        //   { required: true, message: '请输入支付宝公钥证书', trigger: 'blur' }
        // ],
        // certContent: [
        //   { required: true, message: '请输入应用公钥证书', trigger: 'blur' }
        // ]
      }
    };
  },
  created: function created() {
    this.queryTransferAccountPage();
  },
  methods: {
    onAddAccount: function onAddAccount() {
      this.title = '添加转账账号';
      this.OperationType = 'add';
      this.dialogVisible = true;
    },
    onEditor: function onEditor(alipayAppId) {
      this.title = '编辑转账账号';
      this.OperationType = 'Editor';
      this.queryTransferAccountDetail(alipayAppId);
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.handleReset();
      this.dialogVisible = false;
      this.onInit();
    },
    onInit: function onInit() {
      this.ruFrom = {
        remark: '',
        alipayAppId: '',
        rootCertContent: '',
        publicKey: '',
        privateKey: '',
        alipayPublicCertContent: '',
        certContent: ''
      };
    },
    handleSizeChange: function handleSizeChange(val) {
      this.size = val;
      this.queryTransferAccountPage();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.queryTransferAccountPage();
    },
    queryTransferAccountPage: function () {
      var _queryTransferAccountPage2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.loading = true;
              params = {
                page: this.page,
                size: this.size
              };
              _context.n = 1;
              return (0, _paymentSettings.queryTransferAccountPage)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
              } else {
                this.$message.error(res.msg);
              }
              this.loading = false;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function queryTransferAccountPage() {
        return _queryTransferAccountPage2.apply(this, arguments);
      }
      return queryTransferAccountPage;
    }(),
    submitForm: function submitForm() {
      var _this = this;
      this.$refs.ruFrom.validate(function (valid) {
        if (valid) {
          _this.$confirm('是否保存此设置？', '提示', {
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(function () {
            _this.editTransferAccount();
          });
        } else {
          _this.$message.error('请填写所有必填项');
          return false;
        }
      });
    },
    handleReset: function handleReset() {
      this.$refs.ruFrom.resetFields();
    },
    editTransferAccount: function () {
      var _editTransferAccount2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.loading = true;
              params = (0, _objectSpread2.default)({}, this.ruFrom);
              _context2.n = 1;
              return (0, _paymentSettings.editTransferAccount)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$message.success('操作成功');
                this.queryTransferAccountPage();
                this.onClose();
              } else {
                this.$message.error(res.msg);
              }
              this.loading = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function editTransferAccount() {
        return _editTransferAccount2.apply(this, arguments);
      }
      return editTransferAccount;
    }(),
    onSetDefault: function onSetDefault(alipayAppId) {
      var _this2 = this;
      this.$confirm('<div style="display:flex;justify-content:center;font-weight:bold">确认设置为默认转账账号?</div><div style="display:flex;justify-content:center;color:red;font-weight:bold">注:确认后，原先默认账号将被替换，谨慎操作</div>', '提示', {
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        _this2.setDefaultTransferAccount(alipayAppId);
      });
    },
    setDefaultTransferAccount: function () {
      var _setDefaultTransferAccount2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(alipayAppId) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.loading = true;
              params = {
                alipayAppId: alipayAppId
              };
              _context3.n = 1;
              return (0, _paymentSettings.setDefaultTransferAccount)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$message.success('操作成功');
                this.queryTransferAccountPage();
                this.onClose();
              } else {
                this.$message.error(res.msg);
              }
              this.loading = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function setDefaultTransferAccount(_x) {
        return _setDefaultTransferAccount2.apply(this, arguments);
      }
      return setDefaultTransferAccount;
    }(),
    onDel: function onDel(alipayAppId) {
      var _this3 = this;
      this.$confirm('确认删除此转账账号？', '提示', {
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        _this3.deleteTransferAccount(alipayAppId);
      });
    },
    deleteTransferAccount: function () {
      var _deleteTransferAccount2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(alipayAppId) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.loading = true;
              params = {
                alipayAppId: alipayAppId
              };
              _context4.n = 1;
              return (0, _paymentSettings.deleteTransferAccount)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.$message.success('操作成功');
                this.queryTransferAccountPage();
                this.onClose();
              } else {
                this.$message.error(res.msg);
              }
              this.loading = false;
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function deleteTransferAccount(_x2) {
        return _deleteTransferAccount2.apply(this, arguments);
      }
      return deleteTransferAccount;
    }(),
    queryTransferAccountDetail: function () {
      var _queryTransferAccountDetail2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(alipayAppId) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              this.loading = true;
              params = {
                alipayAppId: alipayAppId
              };
              _context5.n = 1;
              return (0, _paymentSettings.queryTransferAccountDetail)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                this.ruFrom.remark = res.data.remark;
                this.ruFrom.alipayAppId = res.data.alipayAppId;
                this.ruFrom.rootCertContent = res.data.rootCertContent;
                this.ruFrom.publicKey = res.data.publicKey;
                this.ruFrom.privateKey = res.data.privateKey;
                this.ruFrom.alipayPublicCertContent = res.data.publicCertContent;
                this.ruFrom.certContent = res.data.certContent;
              } else {
                this.$message.error(res.msg);
              }
              this.loading = false;
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function queryTransferAccountDetail(_x3) {
        return _queryTransferAccountDetail2.apply(this, arguments);
      }
      return queryTransferAccountDetail;
    }()
  }
};